import HomeView from './../HomeView.vue'
import Statisitcs from './../layout/CollabStatistics.vue'

export const homeRoute = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      key: 'view_das'
    }
  },
  {
    path: '/collab-statistics/:id',
    name: 'statistics',
    component: Statisitcs,
    meta: {
      key: 'view_statistics'
    }
  },
]
